/**
 * @generated SignedSource<<64e494b975683a5fe3459649ad9d1129>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type helpObject_HelpCenterHelpObject$data = {
  readonly __typename: "HelpObjectStoreArticle";
  readonly entityKey: string | null | undefined;
  readonly hidden: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"helpObjectArticle_HelpObjectStoreArticle">;
  readonly " $fragmentType": "helpObject_HelpCenterHelpObject";
} | {
  readonly __typename: "HelpObjectStoreChannel";
  readonly entityKey: string | null | undefined;
  readonly hidden: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"helpObjectChannel_HelpObjectStoreChannel">;
  readonly " $fragmentType": "helpObject_HelpCenterHelpObject";
} | {
  readonly __typename: "HelpObjectStoreRequestForm";
  readonly entityKey: string | null | undefined;
  readonly hidden: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"helpObjectRequestForm_HelpObjectStoreRequestForm">;
  readonly " $fragmentType": "helpObject_HelpCenterHelpObject";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "helpObject_HelpCenterHelpObject";
};
export type helpObject_HelpCenterHelpObject$key = {
  readonly " $data"?: helpObject_HelpCenterHelpObject$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpObject_HelpCenterHelpObject">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "entityKey"
},
v1 = {
  "kind": "ScalarField",
  "name": "hidden"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "helpObject_HelpCenterHelpObject",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "helpObjectRequestForm_HelpObjectStoreRequestForm"
        },
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "type": "HelpObjectStoreRequestForm"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "helpObjectArticle_HelpObjectStoreArticle"
        },
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "type": "HelpObjectStoreArticle"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "helpObjectChannel_HelpObjectStoreChannel"
        },
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "type": "HelpObjectStoreChannel"
    }
  ],
  "type": "HelpCenterHelpObject",
  "abstractKey": "__isHelpCenterHelpObject"
};
})();

(node as any).hash = "92e7a1ca6aaadf96303f02340e31d31c";

export default node;
